import React from 'react';
import SocialLink from '@components/social-links/social-link';
import { MobileSocialLinksProps } from './mobile-social-links.types';
import { motion } from 'framer-motion';
import { socialLinks } from '../../../../../locales/en-GB/data/footer.data';
import { SocialLinksWrapper } from './mobile.social-links.styles';

export const MobileSocialLinks: React.FC<MobileSocialLinksProps> = ({
  withAnimation,
}) => {
  return (
    <SocialLinksWrapper>
      {socialLinks.map((socialLink, index) => (
        <div key={`${index}--${socialLink.type.slice(0, 2)}`}>
          {withAnimation ? (
            <motion.div
              key={`${socialLink.type.slice(0, 2)}--${index}`}
              initial={{ opacity: 0, y: 50 }}
              animate={{
                opacity: 1,
                y: 0,
                transition: { delay: index * 0.05 + 0.2 },
              }}
            >
              <SocialLink
                type={socialLink.type}
                url={socialLink.url}
                alt={socialLink.alt}
                width={socialLink.width}
                height={socialLink.height}
                fill={'white'}
                to={socialLink.url}
              />
            </motion.div>
          ) : (
            <SocialLink
              type={socialLink.type}
              url={socialLink.url}
              alt={socialLink.alt}
              width={socialLink.width}
              height={socialLink.height}
              fill={'white'}
              to={socialLink.url}
            />
          )}
        </div>
      ))}
    </SocialLinksWrapper>
  );
};
